import { isDEVMODE, viewStorage } from '../_globals'
import { gsap } from 'gsap'
import Form from "./form";

export default class Newsletter {

  constructor(container = viewStorage.current) {

    this.DOM = {
      container: container.querySelector('section.newsletter'),
      form: viewStorage.current.querySelector('section.newsletter form')
    }

    if (this.DOM.container) {
      this.init()
      viewStorage.hasNewsletter = true
    }
  }

  init() {}

  destroy() {

    // if (isDEVMODE) console.log('Destroy Newsletter')
    this.TL.kill()
    viewStorage.hasNewsletter = false

  }
}
